module.exports = __webpack_public_path__ + "static/media/ic_big_note.c12fe330.svg";